import { useState, useEffect } from "react";
import { UserAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { sendEmailVerification } from "firebase/auth";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";
import "../styles/auth.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

const VerifyEmail = () => {
  const { user, loading } = UserAuth();
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const T = translations[lang].verifyEmail;
  const Tg = translations[lang];

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isResending, setIsResending] = useState(false);

  const checkEmailVerification = async () => {
    if (user) {
      try {
        await user.reload();
        if (user.emailVerified) {
          navigate("/");
        }
      } catch (error) {
        console.error("Error reloading user:", error);
      }
    }
  };

  const handleResendVerification = async () => {
    try {
      setError("");
      setIsResending(true);
      if (user && !user.emailVerified) {
        await sendEmailVerification(user);
        setMessage(T.sent);
      }
    } catch (err) {
      setError(err.message || T.failedResend);
    } finally {
      setIsResending(false);
    }
  };

  useEffect(() => {
    if (!user) {
      navigate("/signin");
      return;
    }

    if (user.emailVerified) {
      navigate("/");
      return;
    }

    const interval = setInterval(() => {
      checkEmailVerification();
    }, 3000);

    return () => clearInterval(interval);
  }, [user, navigate]);

  if (loading) {
    return <div className="loading">{Tg.loading}</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <div className="auth-container">
      <h1 className="auth-title">{T.title}</h1>

      <div style={{ textAlign: "center", marginBottom: "30px" }}>
        <div style={{ fontSize: "64px", marginBottom: "20px" }}><FontAwesomeIcon icon={faEnvelope} /></div>
        <p style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
          {T.sentTo} <strong>{user.email}</strong>
        </p>
        <p style={{ color: "#666", fontSize: "16px", lineHeight: "1.6", marginTop: "10px" }}>
          {T.checkInbox}
        </p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}

      <div style={{ textAlign: "center" }}>
        <button
          onClick={handleResendVerification}
          disabled={isResending}
          className="btn btn-primary"
          style={{ marginBottom: "15px" }}
        >
          {isResending ? T.sending : T.resend}
        </button>

        <p style={{ color: "#666", fontSize: "14px", marginTop: "20px" }}>
          {T.afterVerify}
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
